import { ReactElement } from "react";
import ComponentsList from "../../../../components/Shared/ComponentsList";
import { IComponent } from "../../../../services/http/component/models/IComponent";
import { className } from "../../../../shared/helpers";
import styles from "./Breadcrumb.module.scss";

interface BreadcrumbProps
{
    components: IComponent[];
    component: IComponent;
}

const Breadcrumb = (props: BreadcrumbProps): ReactElement => {
    
    return <ComponentsList components={props.components} component={props.component} {...className(styles.breadcrumb, { [styles.singleComponent]: props.components.length === 1 })}  />
    
};

export default Breadcrumb;